import gql from 'graphql-tag';
import { eventReportDataFragment } from './fragments';

export const reportTemplates = gql`
  query reportTemplates($condominiumPersonContextId: ID) {
    reportTemplates(condominiumPersonContextId: $condominiumPersonContextId) {
      id
      fieldName
      isCustom
      reportFilters {
        id
        key
        isRequired
        sequence
        isAdvanced
      }
    }
  }
`;

export const cancelReport = gql`
  query cancelReport($id: ID!) {
    cancelReport(id: $id)
  }
`;

export const paginationInfoFragment = gql`
  fragment PaginationInfoParts on Pagination {
    page
    totalPages
    pageSize
    totalResults
    hasPrevious
    hasNext
  }
`;

export const usersReportData = gql`
  query usersReportData($reportData: ReportDataInput!) {
    usersReportData(reportData: $reportData) {
      collection {
        personName: personname
        personId: personid
        profileName: profilename
        unityGroupName: unitygroupname
        unityName: unityname
        personEmail: personemail
        personPhone: personphone
        accessProfiles: accessprofiles
        tagAmount
        rfAmount
        appactivated
        creationDate
        creationTime
        additionalInformation
        startBookingTime: startbookingtime
        endBookingTime: endbookingtime
      }
      pagination {
        ...PaginationInfoParts
      }
    }
  }
  ${paginationInfoFragment}
`;

export const eventsReportData = gql`
  query eventsReportData($reportData: ReportDataInput) {
    eventsReportData(reportData: $reportData) {
      collection {
        ...EventReportDataParts
      }
      pagination {
        ...PaginationInfoParts
      }
    }
  }
  ${paginationInfoFragment}
  ${eventReportDataFragment}
`;

export const vehiclesReportData = gql`
  query vehiclesReportData($reportData: ReportDataInput) {
    vehiclesReportData(reportData: $reportData) {
      collection {
        unityGroupName: unitygroupname
        unityName: unityname
        vehicleType: vehicletype
        vehicleModel: vehiclemodel
        vehiclePlate: vehicleplate
        vehiclePersonName: vehiclepersonname
      }
      pagination {
        ...PaginationInfoParts
      }
    }
  }
  ${paginationInfoFragment}
`;

export const registerLicensePlateReportData = gql`
  query registerLicensePlateReportData($reportData: ReportDataInput) {
    registerLicensePlateReportData(reportData: $reportData) {
      collection {
        ...EventReportDataParts
      }
      pagination {
        ...PaginationInfoParts
      }
    }
  }
  ${paginationInfoFragment}
  ${eventReportDataFragment}
`;

export const licensePlatePhotoUrl = gql`
  query licensePlatePhotoUrl(
    $eventId: ID!
    $creationDateEvent: String!
    $hasGuidS3: Boolean!
  ) {
    licensePlatePhotoUrl(
      eventId: $eventId
      creationDateEvent: $creationDateEvent
      hasGuidS3: $hasGuidS3
    ) {
      urlS3
      mediaType
    }
  }
`;
